module.exports = __webpack_public_path__ + "img/helena-logo.efa3c2d9.jpg";